export default {
  Container: require('@/components/Container/Container.vue').default,
  Button: require('@/components/Button/Button.vue').default,
  Page: require('@/components/Page.vue').default,
  Icon: require('@/components/Icon.vue').default
}
